export const formData = (data: Record<string, any>) => {
  const fd = new FormData();
  for (const name in data) {
    fd.append(name, data[name]);
  }

  return fd;
};
